import {
  object,
  array,
  number,
  string,
  date,
  // bool,
} from 'yup';

import mergeSchemas from '../../../utilities/mergeSchemas';


export const naturalPersonValidationSchema = object().shape({
  birthDate: date().required().label('Date of birth'),
  // isPolitician: bool().required().label('Politically exposed person'),
  nationalityId: number().required().label('Nationality'),
});

export const legalEntityValidationSchema = object().shape({
  companyType: string().required(),
});

export const watchListEntryCommonValidationSchema = object().shape({
  name: object().shape({
    firstName: string().required().label('First name'),
    lastName: string().required().label('Last name'),
  }),
  type: number().required(),
  identifications: array().of(
    object().shape({
      number: string().required().label('Identification number'),
    }),
  ),
  addresses: array().of(
    object().shape({
      countryId: number().required().label('Country'),
    }),
  ),
});

export const watchListNaturalPersonEntryValidationSchema = mergeSchemas(
  naturalPersonValidationSchema,
  watchListEntryCommonValidationSchema,
);

export const watchListLegalEntityEntryValidationSchema = mergeSchemas(
  watchListEntryCommonValidationSchema,
  legalEntityValidationSchema,
);


// WEBPACK FOOTER //
// ./src/features/watch-list-entry-high-risk-country/validation-schemas/watchListEntryValidationSchema.js